export default __webpack_public_path__ + "images/FLYBAIR.18e7bc3.png";